<template>
    <hb-modal 
        title="Change Access Code"    
        v-model="dialog" 
        size="medium"
    >
        <template v-slot:subheader>
            Change the access codes of the desired authorized contacts.
        </template>
        <template v-slot:content>
            <v-row v-for="(authorizedContact, index) in authorizedContactsForm" :key="authorizedContact.id" no-gutters>
                <v-col>
                    <hb-form :label="authorizedContact.first + ' ' + authorizedContact.last" full>
                        <v-row class="my-n3 mx-n2">
                            <AccessCodeSelector
                                v-model="authorizedContact.pin"
                                :property-id="propertyId"
                                :area-id="areaId"
                                :generateOnMounted="false"
                                v-validate="validationRule"
                                :data-vv-name="'authorizedCode' + index"
                                :data-vv-as="'Gate Code ' + (index + 1)"
                                :error="errors.has('gateCode.authorizedCode' + index)"
                                data-vv-scope="gateCode"
                            />
                        </v-row>
                    </hb-form>
                </v-col>
            </v-row>
        </template>
        <template v-slot:right-actions>
            <hb-btn 
                color="primary" 
                @click="updateAccessCodes"
                :disabled="updatingCodes || fetchingCodes"
                :loading="updatingCodes || fetchingCodes"
            >
                Save
            </hb-btn>       
        </template>
    </hb-modal>
</template>


<script type="text/babel">

import { notificationMixin } from  '../../mixins/notificationMixin.js';
import api from '../../assets/api.js';
import AccessCodeSelector from './AccessCodeSelector.vue'

export default {
    name: "AuthorizedContactCodeSelector",
    mixins: [ notificationMixin ],
    components: {
        AccessCodeSelector
    },
    data(){
        return {
            updatingCodes: false,
            fetchingCodes: false,
            editingAuthorizedContacts: [],
            authorizedContactsForm: [],
            pinMin: null,
            pinMax: null,
            defaultPinMin: 3,
            defaultPinMax: 12,
            validateLeadingZeros: false
        }
    },
    props:{
        value:{
            type: Boolean,
            default: false
        },
        propertyId:{
            type: String
        },
        unitId:{
            type: String
        },
        areaId:{
            type: String
        },
        contactId:{
            type: String
        },
        authorizedContacts: {
            type: Array,
            required: true
        }
    },
    computed:{
        dialog: {
            get () {
                return this.value;
            },
            set (value) {
                this.$emit('input', value);
            }
        },
        validationRule(){
            let validationPinMin = this.pinMin || this.defaultPinMin
            let validationPinMax = this.pinMax || this.defaultPinMax
            if(this.validateLeadingZeros){
                return 'required|numeric|leadindZeros|min:' + validationPinMin + '|max:' + validationPinMax
            }else{
                return 'required|numeric|min:' + validationPinMin + '|max:' + validationPinMax;
            }
            
        },
    },
    async created() {
        if (this.authorizedContacts?.length) this.setFormAuthorizedContacts(this.authorizedContacts);
        if (this.propertyId) this.getPinFormat()
    },
    methods:{
        // async getAuthorizedContactCodes() {
        //     this.fetchingCodes = true
        //     this.authorizedContacts = []
        //     this.authorizedContactsForm = []
        //     try {
        //         let r = await api.get(this, `${api.ACCESS_CONTROL}properties/${this.propertyId}/units/${this.unitId}/authorized-contacts`);
        //         let authorizedContacts = r?.authorizedContacts
        //         if (authorizedContacts?.length && this.contactId) {
        //             authorizedContacts = authorizedContacts.filter(authContact => authContact.hb_contact_id === this.contactId)
        //         }
        //         this.authorizedContacts = authorizedContacts ?? []
        //         this.authorizedContactsForm = authorizedContacts?.length ? JSON.parse(JSON.stringify(authorizedContacts)) : []
        //     } catch (err) {
        //         this.authorizedContacts = []
        //         this.authorizedContactsForm = []
        //     } finally {
        //         this.fetchingCodes = false
        //     }
        // },
        async updateAccessCodes() {
            try {
                this.updatingCodes = true;
                const isValid = await this.$validator.validateAll('gateCode');
                if (!isValid) {
                    this.showMessageNotification({ type: 'error', description: 'There are errors in your form, correct them before continuing.', list: this.errors.items });
                } else {
                    if (this.authorizedContactsForm?.length) {
                        for (const authorizedContactIndex in this.authorizedContactsForm) {
                            let formPin = this.authorizedContactsForm[authorizedContactIndex].pin
                            let savedPin = this.editingAuthorizedContacts[authorizedContactIndex].pin
                            let authContactId = this.editingAuthorizedContacts[authorizedContactIndex].hb_contact_id
                            if (formPin !== savedPin) {
                                await this.validatePinCode(formPin, authContactId)
                                let r = await api.put(this, 
                                    `${api.ACCESS_CONTROL}properties/${this.propertyId}/areas/${this.areaId}/authorized-contacts/${authContactId}`, 
                                    { pin: formPin }
                                );
                            }
                        }
                    }
                    this.$emit('input', false);
                }
                this.updatingCodes = false;
            } catch (err) {
                this.showMessageNotification({type: "error", description: err, });
                this.updatingCodes = false;
            }
        },
        async validatePinCode(pin, contact_id) {
             let r = await api.post(
                this,
                `${api.PROPERTIES}${this.propertyId}/areas/${this.areaId}/validate-access-code`,
                {code: pin, contact_id}
            );
        },
        setFormAuthorizedContacts(authorizedContactArray) {
            this.editingAuthorizedContacts = authorizedContactArray ?? []
            this.authorizedContactsForm = authorizedContactArray?.length ? JSON.parse(JSON.stringify(authorizedContactArray)) : []
        },
        async getPinFormat(){
            try {
                let r = await api.get(this, api.PROPERTIES + this.propertyId + '/access')

                if(r?.property_access_name === 'PTI' || r?.property_access_name === 'PTI Cloud') {
                    this.validateLeadingZeros = true
                } else {
                    this.validateLeadingZeros = false
                }
                this.pinMin = r?.access?.Credentials?.pin_min || this.defaultPinMin
                this.pinMax = r?.access?.Credentials?.pin_max || this.defaultPinMax
            } catch (err) {
                console.log(err)
            }
        }
    },
    watch: {
        dialog(val) {
            if (val) {
                // this.getAuthorizedContactCodes()
            }
        },
        authorizedContacts(authorizedContactArray) {
            this.setFormAuthorizedContacts(authorizedContactArray)
        },
        propertyId() {
            this.getPinFormat()
        }
    }
}
</script>